define(
  'modules/asset-loader',
  [
    'modules/utils',
    'jquery'
  ],
  function (
    M_Utils,
    $
  ) {
    'use strict';

    var selectors = {
      introVideo: '.js-anim-intro-loader-media video',
      revealVideo: '.js-anim-reveal-media',
      navTileImages: {
        exteriorFeatures: {
          mobile: '.js-nav-exterior-tile-bg-features-mobile',
          desktop: '.js-nav-exterior-tile-bg-features-desktop'
        },
        exteriorSpinA: {
          mobile: '.js-nav-exterior-tile-bg-spin-a-mobile',
          desktop: '.js-nav-exterior-tile-bg-spin-a-desktop'
        },
        exteriorSpinB: {
          mobile: '.js-nav-exterior-tile-bg-spin-b-mobile',
          desktop: '.js-nav-exterior-tile-bg-spin-b-desktop'
        },
        interiorFeatures: {
          mobile: '.js-nav-interior-tile-bg-features-mobile',
          desktop: '.js-nav-interior-tile-bg-features-desktop'
        },
        interiorSpinA: {
          mobile: '.js-nav-interior-tile-bg-spin-a-mobile',
          desktop: '.js-nav-interior-tile-bg-spin-a-desktop'
        },
        interiorSpinB: {
          mobile: '.js-nav-interior-tile-bg-spin-b-mobile',
          desktop: '.js-nav-interior-tile-bg-spin-b-desktop'
        }
      }
    }

    function init (config) {
      loadIntroRevealVideos(config);
      loadNavTileImages(config);
    }

    function loadIntroRevealVideos (config) {
      var deviceCategory = M_Utils.getDeviceCategory();
      var $loadingVideo = $(selectors.introVideo);
      var url = (config.manifest.streamingVideo.loader[deviceCategory])? config.manifest.streamingVideo.loader[deviceCategory] : config.manifest.streamingVideo.loader.src;

      $loadingVideo[0].src = url;

      M_Utils.onVideoLoaded($loadingVideo[0], function () {
        M_Utils.triggerEvent('nx-assetloaded-loadingvideo');
      });

      var $transitionVideo = $(selectors.revealVideo);
      var url2 = (config.manifest.streamingVideo.transition[deviceCategory])? config.manifest.streamingVideo.transition[deviceCategory] : config.manifest.streamingVideo.transition.src;

      $transitionVideo[0].src = url2;

      M_Utils.onVideoLoaded($transitionVideo[0], function () {
        M_Utils.triggerEvent('nx-assetloaded-transitionvideo', {transitionVideoLoaded: true});
      });
    }

    function loadNavTileImages (config) {
      $(selectors.navTileImages.interiorFeatures.mobile).css({'background-image': 'url(' + config.manifest.navTileImages.interiorFeaturesMobile + ')'});
      $(selectors.navTileImages.interiorFeatures.desktop).css({'background-image': 'url(' + config.manifest.navTileImages.interiorFeaturesDesktop + ')'});
      $(selectors.navTileImages.interiorSpinA.mobile).css({'background-image': 'url(' + config.manifest.navTileImages.interiorSpinAMobile + ')'});
      $(selectors.navTileImages.interiorSpinA.desktop).css({'background-image': 'url(' + config.manifest.navTileImages.interiorSpinADesktop + ')'});
      $(selectors.navTileImages.interiorSpinB.mobile).css({'background-image': 'url(' + config.manifest.navTileImages.interiorSpinBMobile + ')'});
      $(selectors.navTileImages.interiorSpinB.desktop).css({'background-image': 'url(' + config.manifest.navTileImages.interiorSpinBDesktop + ')'});
      $(selectors.navTileImages.exteriorFeatures.mobile).css({'background-image': 'url(' + config.manifest.navTileImages.exteriorFeaturesMobile + ')'});
      $(selectors.navTileImages.exteriorFeatures.desktop).css({'background-image': 'url(' + config.manifest.navTileImages.exteriorFeaturesDesktop + ')'});
      $(selectors.navTileImages.exteriorSpinA.mobile).css({'background-image': 'url(' + config.manifest.navTileImages.exteriorSpinAMobile + ')'});
      $(selectors.navTileImages.exteriorSpinA.desktop).css({'background-image': 'url(' + config.manifest.navTileImages.exteriorSpinADesktop + ')'});
      $(selectors.navTileImages.exteriorSpinB.mobile).css({'background-image': 'url(' + config.manifest.navTileImages.exteriorSpinBMobile + ')'});
      $(selectors.navTileImages.exteriorSpinB.desktop).css({'background-image': 'url(' + config.manifest.navTileImages.exteriorSpinBDesktop + ')'});
    }

    return {
      init: init
    }
});

